import React from "react";
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../src/components/ui/table";
import {
  cartDetails,
  cartItem,
} from "../products/productInterface";
import RemoveFromCart from "../../../src/components/removeFromCart";
import { Button } from "../../../src/components/ui/button";
import { useNavigate } from "react-router-dom";
import UpdateProductQuatity from "./updateProductQuatity";

export function CartTable({ cart }: { cart: cartDetails }) {
  const nav = useNavigate();

  return cart?.items?.length < 1 ||
    cart.items === undefined ? (
    <div className="w-full flex flex-col justify-center items-center gap-5 h-96">
      <p className="font-montserrat text-xl">
        Your cart is empty!
      </p>
      <Button
        onClick={() => nav("/shop")}
        className="font-montserrat rounded-none w-36"
      >
        SHOP NOW
      </Button>
    </div>
  ) : (
    <Table className="w-full font-montserrat">
      <TableCaption>
        A list of your cart items.
      </TableCaption>
      <TableHeader>
        <TableRow>
          <TableHead className="w-[10px]"></TableHead>
          <TableHead className="w-[50px] pl-10">
            Item
          </TableHead>
          <TableHead className="w-[10px] text-right">
            Price
          </TableHead>
          <TableHead className="text-left pl-10">
            Quantity
          </TableHead>
          <TableHead className="w-[30px] text-right">
            Subtotal
          </TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {cart?.items?.map((cartItem: cartItem) => (
          <TableRow key={cartItem.id}>
            <TableCell className="w-10">
              <RemoveFromCart
                itemId={cartItem.item_key}
                cart
                name={cartItem.name.toLocaleUpperCase()}
              />
            </TableCell>
            <TableCell className="font-medium">
              <div className="flex justify-center items-center gap-5">
                <img
                  src={cartItem.featured_image}
                  alt={cartItem.name}
                  className="w-16"
                />
                <p className="w-[240px] line-clamp-2">
                  {cartItem.name.toLocaleUpperCase()}
                </p>
              </div>
            </TableCell>
            <TableCell className="text-center">
              {Number(cartItem?.price) / 100}.00$
            </TableCell>
            <TableCell className="text-center">
              <UpdateProductQuatity
                productId={String(cartItem.item_key)}
                quantity={String(cartItem.quantity.value)}
              />
            </TableCell>
            <TableCell className="text-right">
              {Number(cartItem.totals.subtotal) / 100}.00$
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
